import { mapQuestionIndexToPercentage, TOTAL_QUESTIONS } from "./GameUtils";

/**
 * case rawAverage = 11.88
 *   map neighboured integers to percentage:
 *     11, 12
 *     35%, 30%
 *   scale remainder on difference between mapped:
 *     0.88 * 5 = 4,4
 *   subtract scaled remainder from lower:
 *     35% - 4.4 = 30.6%
 */
export function mapRawAverageToPercentageQuestionAverage(rawAverage) {
    const lowerNeighbourInt = Math.floor(rawAverage);
    const higherNeighbourInt = lowerNeighbourInt+1;
    
    const lowerMappedPercentage = mapQuestionIndexToPercentage(lowerNeighbourInt);
    const higherMappedPercentage = mapQuestionIndexToPercentage(higherNeighbourInt) ?? lowerMappedPercentage;

    const remainder = rawAverage - lowerNeighbourInt;
    const difference = lowerMappedPercentage - higherMappedPercentage;
    const scaledRemainder = remainder * difference;

    const finalValue = lowerMappedPercentage - scaledRemainder;

    return finalValue.toPrecision(4);
}


export function getFinalScoreDistribution(scores) {
    // const groups = Object.groupBy(scores, x => x);
    const groups = scores.reduce((acc, x) => {
        acc[x] ??= [];
        acc[x].push(x);
        return acc;
    }, {});

    const counts = Array.from(
        { length: Math.max(...scores) + 1 },
        (_, i) => (groups[i]?.length ?? 0) 
    );

    return counts;
}

export function getLabelsForAllQuestions() {
    return [...Array(TOTAL_QUESTIONS).keys()].map(mapQuestionIndexToPercentage).map(x => `${x}%`);
}

export function mapAnswersToJokerUsedIndices(answers) {
    return answers
        .map((e, i) => e === "JOKER" ? i : -1)
        .filter((i) => i !== -1)
}

